var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.isLoggedIn
        ? _c("header", { staticClass: "header container-fluid" }, [
            _c(
              "div",
              { staticClass: "navHead fixed-top" },
              [
                _c(
                  "b-navbar",
                  {
                    attrs: {
                      toggleable: "lg",
                      type: "light",
                      variant: "transparent",
                    },
                  },
                  [
                    _c("div", { staticClass: "brand" }, [
                      _c("a", { attrs: { href: "/" } }, [
                        _c("span", { staticClass: "logo" }),
                      ]),
                      _vm._v(" "),
                      !_vm.isAdmin
                        ? _c("h4", { staticClass: "pageTitle" }, [
                            _vm._v(_vm._s(_vm.$t("header.title"))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isAdmin
                        ? _c("h4", { staticClass: "pageTitle" }, [
                            _vm._v("Administrator Panel"),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "menuControl" }, [
                      _c("div", { staticClass: "languageSwitch" }, [
                        _c(
                          "a",
                          {
                            class: _vm.enButton,
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.changeLanguage("en")
                              },
                            },
                          },
                          [_c("svg-image", { attrs: { image: "flag-en" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            class: _vm.idButton,
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.changeLanguage("id")
                              },
                            },
                          },
                          [_c("svg-image", { attrs: { image: "flag-id" } })],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "logouter" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "/signin" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.logout.apply(null, arguments)
                              },
                            },
                          },
                          [_c("svg-image", { attrs: { image: "logout" } })],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view", { staticClass: "view" })],
        1
      ),
      _vm._v(" "),
      _c(
        "footer",
        { staticClass: "footer container-fluid" },
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "footnote", attrs: { md: "12" } }, [
                _c("p", [_vm._v("© Borobudur Marathon")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://borobudurmarathon.com/faq",
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("footer.faq")))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://borobudurmarathon.com/terms-policy/",
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("footer.tnp")))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "link",
                    attrs: {
                      href: "https://borobudurmarathon.com/contact",
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("footer.contact")))]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "loading-wrapper" } }, [
      _c("div", { attrs: { id: "loading-text" } }, [_vm._v("RUNNING")]),
      _vm._v(" "),
      _c("div", { attrs: { id: "loading-content" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/App.vue